import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    eyebrow: "Para organizadores",
    title: "¿Organizas eventos? Súmate gratis.",
    body: "Publica tus panoramas y llega a miles de personas buscando qué hacer en su comuna.",
    countPre: " Ya somos ",
    count: (n: number) => `${n} organizaciones`,
    countPost: " activas en la plataforma.",
    cta: "Publicar mi evento",
  },
  en: {
    eyebrow: "For organizers",
    title: "Do you organize events? Join for free.",
    body: "Post your events and reach thousands of people looking for things to do in their neighborhood.",
    countPre: " There are already ",
    count: (n: number) => `${n} organizations`,
    countPost: " active on the platform.",
    cta: "Post my event",
  },
});
